import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "d-flex" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-times" }, null, -1)
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" Ocultar Panel ")
const _hoisted_4 = {
  key: 0,
  class: "m-0 text-white"
}
const _hoisted_5 = { class: "color-regular label-text" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-user-plus" }, null, -1)
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" Compartir ")
const _hoisted_8 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-exchange-alt" }, null, -1)
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" Reasignar ")
const _hoisted_10 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-people-arrows" }, null, -1)
const _hoisted_11 = /*#__PURE__*/_createTextVNode(" Cambiar cuenta ")
const _hoisted_12 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-user-lock" }, null, -1)
const _hoisted_13 = /*#__PURE__*/_createTextVNode(" Asignar cuenta ")
const _hoisted_14 = /*#__PURE__*/_createElementVNode("span", { class: "subtitle" }, " Información del Ticket ", -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("span", { class: "info" }, "Pri. mensaje: ", -1)
const _hoisted_16 = { class: "text-default" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("span", { class: "info" }, "Últ. mensaje: ", -1)
const _hoisted_18 = { class: "text-default" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("span", { class: "info" }, "En curso: ", -1)
const _hoisted_20 = { class: "text-default" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("span", { class: "info" }, "Cuenta: ", -1)
const _hoisted_22 = { class: "text-default" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("span", { class: "info" }, "Teléfono: ", -1)
const _hoisted_24 = { class: "text-default" }
const _hoisted_25 = { class: "w-100 d-flex align-items-center" }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("div", { style: {"width":"92% !important"} }, [
  /*#__PURE__*/_createElementVNode("span", { class: "info label-text" }, "Identificadores: "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-default" }, " Sin Registro")
], -1)
const _hoisted_27 = {
  key: 0,
  class: "m-0 my-2"
}
const _hoisted_28 = /*#__PURE__*/_createElementVNode("span", { class: "info" }, "Carteras: ", -1)
const _hoisted_29 = { class: "m-0" }
const _hoisted_30 = { class: "text-default" }
const _hoisted_31 = /*#__PURE__*/_createElementVNode("span", { class: "info" }, "Carteras: ", -1)
const _hoisted_32 = /*#__PURE__*/_createElementVNode("span", { class: "text-default" }, " Sin Registro", -1)
const _hoisted_33 = { class: "container bg-white" }
const _hoisted_34 = /*#__PURE__*/_createElementVNode("div", { class: "row mb-2" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "color-regular" }, "Calificación del usuario")
], -1)
const _hoisted_35 = { class: "container bg-white" }
const _hoisted_36 = /*#__PURE__*/_createElementVNode("div", { class: "row" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "color-regular" }, "Participantes ")
], -1)
const _hoisted_37 = /*#__PURE__*/_createElementVNode("div", { class: "row pt-3 pb-2" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "subtitle" }, " Clientes ")
], -1)
const _hoisted_38 = { class: "col-2" }
const _hoisted_39 = {
  key: 0,
  class: "m-0 text-white"
}
const _hoisted_40 = { class: "col-10" }
const _hoisted_41 = { class: "color-regular fs-base" }
const _hoisted_42 = /*#__PURE__*/_createElementVNode("div", { class: "row pt-3 pb-2" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "subtitle" }, " Agentes ")
], -1)
const _hoisted_43 = { key: 0 }
const _hoisted_44 = { class: "col-2" }
const _hoisted_45 = {
  key: 0,
  class: "m-0 text-white"
}
const _hoisted_46 = { class: "col-10" }
const _hoisted_47 = { class: "color-regular fs-base" }
const _hoisted_48 = { class: "container bg-white" }
const _hoisted_49 = /*#__PURE__*/_createElementVNode("div", { class: "row mb-2" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "color-regular" }, "Etiquetas")
], -1)
const _hoisted_50 = { class: "container bg-white" }
const _hoisted_51 = /*#__PURE__*/_createElementVNode("div", { class: "row mb-2" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "color-regular" }, "Comentario")
], -1)
const _hoisted_52 = { class: "container bg-white" }
const _hoisted_53 = /*#__PURE__*/_createElementVNode("div", { class: "row mb-2" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "color-regular" }, "Respuestas Rápidas")
], -1)
const _hoisted_54 = { class: "container bg-white" }
const _hoisted_55 = /*#__PURE__*/_createElementVNode("div", { class: "row mb-2" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "color-regular" }, "Tipificación")
], -1)
const _hoisted_56 = { class: "container bg-white" }
const _hoisted_57 = /*#__PURE__*/_createElementVNode("div", { class: "row mb-2" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "color-regular" }, "Tickets actuales")
], -1)
const _hoisted_58 = { class: "container bg-white" }
const _hoisted_59 = /*#__PURE__*/_createElementVNode("div", { class: "row mb-2" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "color-regular" }, "Últimos Tickets")
], -1)

import { ref, computed, onMounted, onUnmounted, watch } from "vue";
import { getInitials } from "@/util/utils";
import { TicketModule } from "@/store/modules/Ticket";
import { AccountModule } from "@/store/modules/Account";
import { Modals, ModalSidebarState } from "@/types/components";
import { DateTime, Duration } from "ts-luxon";
import Tags from "@/omnichannel/components/ticketSidebar/Tags.vue";
import Coment from "@/omnichannel/components/ticketSidebar/Coment.vue";
import QuickReplies from "@/omnichannel/components/ticketSidebar/QuickReplies.vue";
import Typifications from "@/omnichannel/components/ticketSidebar/Typifications.vue";
import IdentificatorsControl from "./IdentificatorsControl.vue";
import LastTickets from "@/omnichannel/components/ticketSidebar/LastTickets.vue";
import Rate from "./Rate.vue";
import NameUpdate from "./NameUpdate.vue";
import IdentificationAdd from "./IdentificationAdd.vue";
import CurrentTickets from "./CurrentTickets.vue";
import { env } from "@/config";
import { IdentificationModule } from "@/store/modules/Identification";
import { whatsappInterfaces } from "@/store/actions/ticket.actions";
import ButtonsDynamic from "./ButtonsDynamic.vue";
// Data

export default /*#__PURE__*/_defineComponent({
  emits: ["changeModal", "showClientName", "showIdentificationAdd"],
  setup(__props, { emit: emits }: { emit: ({
	(e: "changeModal", t: { modal: Modals; payload: ModalSidebarState }): void;
	(e: "showClientName"): void;
	(
		e: "showIdentificationAdd",
		payload: {
			coincidences: Array<any> | undefined;
			identifier: string | undefined;
		}
	): void;
}), expose: any, slots: any, attrs: any }) {

const _height = ref(window.innerHeight - 109);
const editName = ref(false);
const deleteIdentification = ref(-1);
const addIdentification = ref(false);
const inProgress = ref(0); // Tiempo en segundos
const timer = ref();

// Computed
const ticket = computed(() => TicketModule.currentTicket);
const account = computed(() =>
	AccountModule.Accounts.find(
		a => a._id === TicketModule.currentTicket?.account
	)
);
const tagsList = computed(() => AccountModule.tags);
const wallets = computed(() => TicketModule.Wallets);
const ticketFilter = computed(
	() =>
		TicketModule.Filter === "closed" ||
		TicketModule.Filter === "archived" ||
		TicketModule.Filter === "bot"
);
const hideControls = computed(
	() => TicketModule.isOldTicket || TicketModule.Filter === "bot"
);



// Methods
function createTimer() {
	timer.value = setInterval(() => {
		inProgress.value += 1;
	}, 1000);
}

function formatDate(date: string) {
	return DateTime.fromISO(date).toRelative();
}

function formatDurationFromSeconds(seconds: number) {
	return Duration.fromMillis(seconds * 1000)
		.shiftTo("day", "hour", "minute", "second")
		.normalize()
		.toHuman({ unitDisplay: "short" });
}

function initializeInProgress(initTimer: boolean) {
	const now = DateTime.now();
	const dateFirstMessage = DateTime.fromISO(ticket.value?.first_msg_date ?? "");
	inProgress.value = Math.round(now.toSeconds() - dateFirstMessage.toSeconds());
	clearInterval(timer.value);
	if (initTimer) createTimer();
}

watch(
	() => [TicketModule.currentRoomID],
	() => {
		if (
			TicketModule.currentRoomID === TicketModule.currentNewestRoom.id &&
			!ticketFilter.value
		)
			initializeInProgress(true);
		else initializeInProgress(false);

		editName.value = false;
		addIdentification.value = false;
		deleteIdentification.value = -1;
	}
);

/* watch(
	() => ticket.value,
	value => {
		console.log(value, "NEW TICKET");
	}
); */

onMounted(() => {
	initializeInProgress(true);
});

onUnmounted(() => {
	clearInterval(timer.value);
});

function onEditClient() {
	if (env.FullClientEdit)
		emits("changeModal", { modal: "editClient", payload: { show: true } });
	else editName.value = true;
}

function saveCoincidences(payload: {
	coincidences: number | undefined;
	identifier: string;
}) {
	if (payload && payload.coincidences)
		IdentificationModule.setFoundCoincidences(
			IdentificationModule.FoundCoincidences || payload.coincidences > 0
		);
	addIdentification.value = false;
}

// events
window.addEventListener(
	"resize",
	() => (_height.value = window.innerHeight - 79)
);

return (_ctx: any,_cache: any) => {
  const _component_base_button = _resolveComponent("base-button")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_card = _resolveComponent("el-card")!

  return (_unref(TicketModule).openedSidebar)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        style: _normalizeStyle({
			height: `${_height.value}px`,
			'overflow-y': 'auto',
			'min-width': '340px',
		}),
        class: "p-3"
      }, [
        _createElementVNode("div", _hoisted_1, [
          _createVNode(_component_base_button, {
            onClick: _cache[0] || (_cache[0] = () => _unref(TicketModule).setOpenedSidebar(false)),
            style: {"width":"100%"},
            type: "secondary"
          }, {
            default: _withCtx(() => [
              _hoisted_2,
              _hoisted_3
            ]),
            _: 1
          })
        ]),
        _createVNode(_component_el_card, { class: "my-2" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_row, { class: "bg-white" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_col, {
                  span: 6,
                  class: "grid-content d-flex justify-content-center align-items-center"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", {
                      class: "vac-avatar d-flex align-items-center justify-content-center",
                      style: _normalizeStyle({
							background: _unref(TicketModule).currentRoom?.avatar
								? `url('${_unref(TicketModule).currentRoom.avatar}')`
								: _unref(TicketModule).currentRoom?.color,
							backgroundSize: 'cover',
							backgroundPosition: 'center center',
						})
                    }, [
                      (!_unref(TicketModule).currentRoom?.avatar)
                        ? (_openBlock(), _createElementBlock("h4", _hoisted_4, _toDisplayString(_unref(getInitials)(_unref(TicketModule).currentRoom?.roomName ?? "")), 1))
                        : _createCommentVNode("", true)
                    ], 4)
                  ]),
                  _: 1
                }),
                (!editName.value)
                  ? (_openBlock(), _createBlock(_component_el_col, {
                      key: 0,
                      span: 18,
                      class: "grid-content d-flex align-items-center"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("span", _hoisted_5, _toDisplayString(_unref(TicketModule).currentRoom?.roomName), 1),
                        (
							!_unref(TicketModule).isOldTicket &&
							_unref(TicketModule).currentTicket?.client.length === 1
						)
                          ? (_openBlock(), _createBlock(_component_el_tooltip, {
                              key: 0,
                              content: "Editar nombre"
                            }, {
                              default: _withCtx(() => [
                                _createElementVNode("i", {
                                  class: "fa fa-edit color-regular fa-xs edit-button",
                                  onClick: onEditClient
                                })
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    }))
                  : (_openBlock(), _createBlock(_component_el_col, {
                      key: 1,
                      span: 18,
                      class: "grid-content d-flex justify-content-between align-items-center"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(NameUpdate, {
                          style: {"width":"100%"},
                          onShowClientName: _cache[1] || (_cache[1] = ($event: any) => (editName.value = false))
                        })
                      ]),
                      _: 1
                    })),
                _createVNode(ButtonsDynamic, {
                  "wrapper-class": "pt-4 pb-2 d-flex align-items-center justify-content-center",
                  size: "md",
                  vertical: ""
                }),
                _createVNode(_component_el_col, { class: "pt-4 pb-2 d-flex align-items-center justify-content-center" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_base_button, {
                      size: "sm",
                      style: {"width":"50%"},
                      type: "secondary",
                      disabled: _unref(hideControls),
                      onClick: _cache[2] || (_cache[2] = 
							() =>
								emits('changeModal', {
									modal: 'sideBarModal',
									payload: { show: true, type: 'share' },
								})
						)
                    }, {
                      default: _withCtx(() => [
                        _hoisted_6,
                        _hoisted_7
                      ]),
                      _: 1
                    }, 8, ["disabled"]),
                    _createVNode(_component_base_button, {
                      size: "sm",
                      style: {"width":"50%"},
                      type: "primary",
                      disabled: _unref(hideControls),
                      onClick: _cache[3] || (_cache[3] = 
							() =>
								emits('changeModal', {
									modal: 'sideBarModal',
									payload: { show: true, type: 'reasign' },
								})
						)
                    }, {
                      default: _withCtx(() => [
                        _hoisted_8,
                        _hoisted_9
                      ]),
                      _: 1
                    }, 8, ["disabled"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, { class: "pt-2 pb-2 d-flex align-items-center justify-content-center" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_base_button, {
                      size: "sm",
                      style: {"width":"50%"},
                      type: "warning",
                      disabled: _unref(hideControls),
                      onclick: 
							() =>
								emits('changeModal', {
									modal: 'accountModal',
									payload: { show: true, type: 'ticket' },
								})
						
                    }, {
                      default: _withCtx(() => [
                        _hoisted_10,
                        _hoisted_11
                      ]),
                      _: 1
                    }, 8, ["disabled", "onclick"]),
                    _createVNode(_component_base_button, {
                      size: "sm",
                      style: {"width":"50%"},
                      type: "success",
                      disabled: _unref(hideControls),
                      onclick: 
							() =>
								emits('changeModal', {
									modal: 'accountModal',
									payload: { show: true, type: 'client' },
								})
						
                    }, {
                      default: _withCtx(() => [
                        _hoisted_12,
                        _hoisted_13
                      ]),
                      _: 1
                    }, 8, ["disabled", "onclick"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, { class: "pt-4 pb-2" }, {
                  default: _withCtx(() => [
                    _hoisted_14
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, { class: "pb-1 fs-base" }, {
                  default: _withCtx(() => [
                    _hoisted_15,
                    _createElementVNode("span", _hoisted_16, _toDisplayString(formatDate(_unref(ticket)?.first_msg_date ?? "")), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, { class: "pb-1 fs-base" }, {
                  default: _withCtx(() => [
                    _hoisted_17,
                    _createElementVNode("span", _hoisted_18, _toDisplayString(formatDate(_unref(ticket)?.last_msg_date ?? "")), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, { class: "pb-1 fs-base" }, {
                  default: _withCtx(() => [
                    _hoisted_19,
                    _createElementVNode("span", _hoisted_20, _toDisplayString(formatDurationFromSeconds(inProgress.value)), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, { class: "pb-1 fs-base" }, {
                  default: _withCtx(() => [
                    _hoisted_21,
                    _createElementVNode("span", _hoisted_22, _toDisplayString(_unref(account)?.name), 1)
                  ]),
                  _: 1
                }),
                (
						!_unref(ticket)?.isGroup &&
						_unref(whatsappInterfaces).includes(_unref(ticket)?.channel?.interface ?? '')
					)
                  ? (_openBlock(), _createBlock(_component_el_col, {
                      key: 2,
                      class: "pb-1 fs-base"
                    }, {
                      default: _withCtx(() => [
                        _hoisted_23,
                        _createElementVNode("span", _hoisted_24, _toDisplayString(_unref(ticket)?.thread.split("@")[0]), 1)
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (
						!_unref(ticket)?.isGroup &&
						(_unref(ticket)?.client[0].identification.length ?? 0) > 0
					)
                  ? (_openBlock(), _createBlock(_component_el_col, {
                      key: 3,
                      class: "pb-1 fs-base"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(IdentificatorsControl)
                      ]),
                      _: 1
                    }))
                  : (!_unref(ticket)?.isGroup)
                    ? (_openBlock(), _createBlock(_component_el_col, {
                        key: 4,
                        class: "pb-1 fs-base"
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_25, [
                            _hoisted_26,
                            (
								!_unref(TicketModule).isOldTicket &&
								_unref(TicketModule).currentTicket?.client.length === 1
							)
                              ? (_openBlock(), _createBlock(_component_el_tooltip, {
                                  key: 0,
                                  placement: "left",
                                  content: "Añadir"
                                }, {
                                  default: _withCtx(() => [
                                    _createElementVNode("i", {
                                      class: "fa fa-plus color-regular fa-xs add-button text-center",
                                      onClick: _cache[4] || (_cache[4] = ($event: any) => (addIdentification.value = true))
                                    })
                                  ]),
                                  _: 1
                                }))
                              : _createCommentVNode("", true)
                          ]),
                          (addIdentification.value)
                            ? (_openBlock(), _createElementBlock("ul", _hoisted_27, [
                                _createVNode(_component_el_row, { lass: "bg-white" }, {
                                  default: _withCtx(() => [
                                    _createVNode(IdentificationAdd, {
                                      onShowIdentificationAdd: _cache[5] || (_cache[5] = payload => saveCoincidences(payload))
                                    })
                                  ]),
                                  _: 1
                                })
                              ]))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                (!_unref(ticket)?.isGroup && (_unref(wallets).length ?? 0) > 0)
                  ? (_openBlock(), _createBlock(_component_el_col, {
                      key: 5,
                      class: "pb-1 fs-base"
                    }, {
                      default: _withCtx(() => [
                        _hoisted_28,
                        _createElementVNode("ul", _hoisted_29, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(wallets), (wallet, index) => {
                            return (_openBlock(), _createBlock(_component_el_row, {
                              key: index,
                              class: "bg-white"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_col, { class: "pb-1 fs-base" }, {
                                  default: _withCtx(() => [
                                    _createElementVNode("li", _hoisted_30, _toDisplayString(wallet.name), 1)
                                  ]),
                                  _: 2
                                }, 1024)
                              ]),
                              _: 2
                            }, 1024))
                          }), 128))
                        ])
                      ]),
                      _: 1
                    }))
                  : (!_unref(ticket)?.isGroup)
                    ? (_openBlock(), _createBlock(_component_el_col, {
                        key: 6,
                        class: "pb-1 fs-base"
                      }, {
                        default: _withCtx(() => [
                          _hoisted_31,
                          _hoisted_32
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true)
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        (!_unref(ticketFilter) && _unref(TicketModule).currentTicket?.rate?.feedback)
          ? (_openBlock(), _createBlock(_component_el_card, {
              key: 0,
              class: "my-2"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_33, [
                  _hoisted_34,
                  _createVNode(Rate)
                ])
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        _createVNode(_component_el_card, { class: "my-2" }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_35, [
              _hoisted_36,
              _hoisted_37,
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(ticket)?.client, (client) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: client._id,
                  class: "row mb-1"
                }, [
                  _createElementVNode("div", _hoisted_38, [
                    _createElementVNode("div", {
                      class: "vac-avatar avatar-mx d-flex align-items-center justify-content-center",
                      style: _normalizeStyle({
								background: client.picture
									? `url('${client.picture}')`
									: _unref(TicketModule).currentRoom?.color,
								backgroundSize: 'cover',
								backgroundPosition: 'center center',
							})
                    }, [
                      (!client.picture)
                        ? (_openBlock(), _createElementBlock("h4", _hoisted_39, _toDisplayString(_unref(getInitials)(client.customer.name)), 1))
                        : _createCommentVNode("", true)
                    ], 4)
                  ]),
                  _createElementVNode("div", _hoisted_40, [
                    _createElementVNode("span", _hoisted_41, _toDisplayString(client.customer.name), 1)
                  ])
                ]))
              }), 128)),
              _hoisted_42,
              (_unref(ticket)?.status !== 'open')
                ? (_openBlock(), _createElementBlock("div", _hoisted_43, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(ticket)?.agent, (agent) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: agent._id,
                        class: "row mb-1"
                      }, [
                        _createElementVNode("div", _hoisted_44, [
                          _createElementVNode("div", {
                            class: "vac-avatar avatar-mx d-flex align-items-center justify-content-center",
                            style: _normalizeStyle({
									background: agent.picture
										? `url('${agent.picture}')`
										: _unref(TicketModule).currentRoom?.color,
									backgroundSize: 'cover',
									backgroundPosition: 'center center',
								})
                          }, [
                            (!agent.picture)
                              ? (_openBlock(), _createElementBlock("h4", _hoisted_45, _toDisplayString(_unref(getInitials)(agent.name)), 1))
                              : _createCommentVNode("", true)
                          ], 4)
                        ]),
                        _createElementVNode("div", _hoisted_46, [
                          _createElementVNode("span", _hoisted_47, _toDisplayString(agent.name), 1)
                        ])
                      ]))
                    }), 128))
                  ]))
                : _createCommentVNode("", true)
            ])
          ]),
          _: 1
        }),
        (_unref(tagsList).length > 0)
          ? (_openBlock(), _createBlock(_component_el_card, {
              key: 1,
              class: "my-2"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_48, [
                  _hoisted_49,
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(tagsList), (tag) => {
                    return (_openBlock(), _createBlock(Tags, {
                      key: tag._id,
                      tag: tag
                    }, null, 8, ["tag"]))
                  }), 128))
                ])
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        _createVNode(_component_el_card, { class: "my-2" }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_50, [
              _hoisted_51,
              _createVNode(Coment)
            ])
          ]),
          _: 1
        }),
        (!_unref(hideControls))
          ? (_openBlock(), _createBlock(_component_el_card, {
              key: 2,
              class: "my-2"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_52, [
                  _hoisted_53,
                  _createVNode(QuickReplies)
                ])
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (!_unref(hideControls))
          ? (_openBlock(), _createBlock(_component_el_card, {
              key: 3,
              class: "my-2"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_54, [
                  _hoisted_55,
                  _createVNode(Typifications)
                ])
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (!_unref(ticketFilter) && _unref(TicketModule).CurrentTicketsFromClient.length > 0)
          ? (_openBlock(), _createBlock(_component_el_card, {
              key: 4,
              class: "my-2"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_56, [
                  _hoisted_57,
                  _createVNode(CurrentTickets)
                ])
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (!_unref(ticketFilter) && _unref(TicketModule).LastTicketsFromClient.length > 0)
          ? (_openBlock(), _createBlock(_component_el_card, {
              key: 5,
              class: "my-2"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_58, [
                  _hoisted_59,
                  _createVNode(LastTickets)
                ])
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ], 4))
    : _createCommentVNode("", true)
}
}

})